import { checkAnyUserType } from '@utils/Util';

const SUPPLIER_STATUS = {
	ACTIVE: 'green-3',
	PIPELINE: 'yellow-3',
	BLACK_LISTED: 'gray-3',
	INACTIVE: 'gray-4',
	ARCHIVED: 'archive',
	NOT_APPROVED: 'not-approved brown'
};

const SUPPLIER_GRADE = {
	GRADING_A: 'gradeA',
	GRADING_B: 'gradeB',
	GRADING_C: 'gradeC',
	GRADING_D: 'gradeD'
};

const isDataEmpty = (item) => (item?.length > 0 ? item : '--');

const renderCertificateBadge = (certificateType) => {
	switch (certificateType) {
		case 'GOTS':
			return process.env.PUBLIC_URL + '/icons/certificates/gots.svg';
		case 'BSCI':
			return process.env.PUBLIC_URL + '/icons/certificates/bsci.svg';
		case 'ISO':
			return process.env.PUBLIC_URL + '/icons/certificates/iso.svg';
		case 'RDS':
			return process.env.PUBLIC_URL + '/icons/certificates/rds.svg';
		case 'RWS':
			return process.env.PUBLIC_URL + '/icons/certificates/rws.svg';
		case 'SCS':
			return process.env.PUBLIC_URL + '/icons/certificates/scs.svg';
		case 'SEDEX':
			return process.env.PUBLIC_URL + '/icons/certificates/sedex.svg';
		case 'OCS':
			return process.env.PUBLIC_URL + '/icons/certificates/ocs.svg';
		case 'GRS':
			return process.env.PUBLIC_URL + '/icons/certificates/grs.svg';
		case 'OEKOTEX':
			return process.env.PUBLIC_URL + '/icons/certificates/orkotex.svg';
		case 'WRAP':
			return process.env.PUBLIC_URL + '/icons/certificates/wrap.svg';
		case 'RSC_ACCORD':
			return process.env.PUBLIC_URL + '/icons/certificates/accord.svg';
		case 'HIGG':
		case 'HIGG_FSLM':
		case 'HIGG_FEM':
			return process.env.PUBLIC_URL + '/icons/certificates/higg.svg';
		case 'RCS_ACCORD':
			return process.env.PUBLIC_URL + '/icons/certificates/rcs.svg';
		case 'SFA':
			return process.env.PUBLIC_URL + '/icons/certificates/sfa.svg';
		case 'CT_PAT':
			return process.env.PUBLIC_URL + '/icons/certificates/ct-pat.svg';
		case 'GSV':
			return process.env.PUBLIC_URL + '/icons/certificates/gsv.svg';
		case 'SCAN':
			return process.env.PUBLIC_URL + '/icons/certificates/scan.svg';
		case 'BETTER_WORK':
			return process.env.PUBLIC_URL + '/icons/certificates/better-work.svg';
		case 'BCI':
			return process.env.PUBLIC_URL + '/icons/certificates/bci.svg';
		case 'CCS':
			return process.env.PUBLIC_URL + '/icons/certificates/ccs.svg';
		case 'RCC_BLENDED':
			return process.env.PUBLIC_URL + '/icons/certificates/rcc.svg';
		case 'FAMA':
			return process.env.PUBLIC_URL + '/icons/certificates/fama.svg';
		case 'SLCP':
			return process.env.PUBLIC_URL + '/icons/certificates/slcp.svg';
		case 'SA800':
			return process.env.PUBLIC_URL + '/icons/certificates/sa800.svg';
		case 'RIR':
			return process.env.PUBLIC_URL + '/icons/certificates/rir.svg';
		case 'FAIR_TRADE':
			return process.env.PUBLIC_URL + '/icons/certificates/fair-trade.svg';
		case 'STEP_BY_OKEO_TEX':
			return process.env.PUBLIC_URL + '/icons/certificates/oeko-tex-step.svg';
		case 'OKEO_TEX_MADE_IN_GREEN':
			return process.env.PUBLIC_URL + '/icons/certificates/oeko-tex-green.svg';
		case 'LEED':
			return process.env.PUBLIC_URL + '/icons/certificates/leed.svg';
		default:
			return '';
	}
};

const TOTAl_ORDER_RGBA = [
	'#C7CED4',
	'#3B82F6',
	'#FCB400',
	'#EE761F',
	'#67AC5B',
	'#FBBEBE',
	'#FDE767',
	'#BF7EFF',
	'#FF5BBE',
	'#F9F2F2',
	'#FF896F',
	'#94D7FF',
	'#E4EE43',
	'#AFFBFB',
	'#BED857',
	'#FF8DD1',
	'#FFC857',
	'#FFACDA',
	'#20B9FB',
	'#D3A67D',
	'#DDBCE5',
	'#86F6CD',
	'#FFB3A3'
];

const GRADE_WISE_STRENGTH = {
	STRENGTH_5: [
		'BSCI',
		'SEDEX',
		'HIGG',
		'FEM',
		'BETTER WORK',
		'WRAP',
		'CT-PAT',
		'SCAN',
		'GSV',
		'BCI',
		'OCS',
		'RCS',
		'GRS',
		'GOTS',
		'OEKO-TEX'
	],
	STRENGTH_4: ['BSCI', 'SEDEX', 'WRAP', 'CT-PAT', 'OCS', 'RCS', 'GRS', 'OEKO-TEX'],
	STRENGTH_3: ['BSCI', 'SEDEX', 'WRAP', 'OEKO-TEX'],
	STRENGTH_2: ['BSCI']
};

const RANK_WISE_STRENGTH = {
	GRADING_A: 'Excellent',
	GRADING_B: 'Above Average ',
	GRADING_C: 'Acceptable',
	GRADING_D: 'Poor'
};

const isAllowEdit = () =>
	checkAnyUserType(['ADMIN', 'SUPPLY_CHAIN', 'MATERIAL_MANAGEMENT', 'INVENTORY_MANAGEMENT']);

const groupSupplierDocuments = (documentList, groupType) => {
	return documentList.reduce((acc, item) => {
		const type = item[groupType];
		if (!acc[type]) {
			acc[type] = [];
		}
		acc[type].push(item);
		return acc;
	}, {});
};

export {
	SUPPLIER_STATUS,
	isDataEmpty,
	SUPPLIER_GRADE,
	renderCertificateBadge,
	TOTAl_ORDER_RGBA,
	GRADE_WISE_STRENGTH,
	RANK_WISE_STRENGTH,
	isAllowEdit,
	groupSupplierDocuments
};
